module.exports = __webpack_public_path__ + "static/img/img1.1fc7542.png";


//////////////////
// WEBPACK FOOTER
// ./static/ios/img1.png
// module id = 7SHk
// module chunks = 0